import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import get from 'lodash/get';
import Panel from 'wonderbly-components/lib/Panel';
import Tooltip from 'wonderbly-components/lib/Tooltip';
import RichText from '../Prismic/RichText';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import Field from './Field';
import Loading from '../../components/Loading';
import './UserForm.scss';

const Fields = ({ renderFields, ...props }) => {
  const fields = get(props, 'form.body') || props.items;
  if (props.isDataLoading) {
    return <Loading dark relative small />;
  }
  return (
    <div className="user-form__fields">
      {fields.map((item, idx) => {
        if (renderFields) {
          return renderFields(item, idx);
        }
        return <Field key={`${item.type}-${idx}`} {...props} field={item} index={idx}/>;
      })}
    </div>
  );
};

Fields.propTypes = {
  isDataLoading: PropTypes.bool,
  items: PropTypes.array.isRequired,
  renderFields: PropTypes.func,
};

const UserForm = props => {
  const formType = get(props, 'form.type') || props.formType;
  const description = get(props, 'form.content') || props.formDescription;

  return (
    <section className={cx('user-form', {
      [`user-form--${formType}`]: formType,
      [props.className]: props.className
    })}>
      <div className={cx({
        'container-guttered': !['shipping-methods', 'shipping-details'].includes(formType),
      })}>
        <form onSubmit={props.handleSubmit}>
          {props.isSubmitted && props.formSubmissionMessage && props.useAlert &&
            <Panel
              className="user-form-alert" background="success">
              <RichText
                fields={props.formSubmissionMessage}
              />
            </Panel>
          }
          <Panel
            className="user-form-panel"
            border="shadow">
            {(!props.isSubmitted || props.useAlert) && (
              <React.Fragment>
                <RichText fields={description} className="panel-form-title" />
                <Tooltip className="error-tooltip" visible={props.errors && !!props.errors.base} absolute={false} type="alert">
                  {props.errors && props.errors.base}
                </Tooltip>
                <Fields {...props} />
              </React.Fragment>
            )}
            {props.isSubmitted && props.formSubmissionMessage && !props.useAlert &&
              <RichText
                fields={props.formSubmissionMessage}
              />
            }
          </Panel>
          {props.ctaLink && props.ctaText &&
            <a href={localiseUrl(props.country, props.ctaLink)} className="back-to-link">
              {props.ctaText}
            </a>
          }
        </form>
      </div>
    </section>
  );
};

UserForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  useAlert: PropTypes.bool,
  formDescription: PropTypes.array,
  formSubmissionMessage: PropTypes.array.isRequired,
  formType: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  errors: PropTypes.shape({
    base: PropTypes.string
  }),
  ctaLink: PropTypes.string,
  ctaText: PropTypes.string,
  className: PropTypes.string,
  country: PropTypes.object,
  isShippingDetails: PropTypes.bool,
  isDataLoading: PropTypes.bool,
  handleClick: PropTypes.func,
  renderFields: PropTypes.func,
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/UserForm.js